'use client';

import { css } from '@bts-web/utils-style-engine';
import { ButtonBase, DialogBase } from '../../../../common';
import { useCancelSavingsPlan } from '../../hooks/useCancelSavingsPlan.use-client';
import { ModalComponent } from '../../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { RegularErrorCircle } from '../../../../common/svgIcons';

interface SavingsPlanCancelModalProps {
  translations: {
    cancelPlan: string;
    goBack: string;
    cancelPlanConfirmationTitle: string;
    cancelPlanConfirmationDescription: string;
    cancelPlanInProgressConfirmationDescription: string;
  };
  savingsPlan: { name: string; id: string };
  isConfirmedTransaction?: boolean;
}

export const SavingsPlanCancelModal: ModalComponent<
  SavingsPlanCancelModalProps
> = ({ translations, onClose, savingsPlan, isConfirmedTransaction }) => {
  const { onConfirm, isLoading } = useCancelSavingsPlan({
    savingsPlan,
  });

  return (
    <DialogBase
      id="base-modal"
      onClose={onClose}
      size="small"
      onMobileFullScreen
      visual="secondary"
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        })}
      >
        <section
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small',
            alignItems: 'center',
            justifyContent: 'center',
            flex: 1,
          })}
        >
          <div
            className={css({
              width: '52px',
              height: '52px',
              color: 'information.text_primary',
              backgroundColor: 'information.fill_secondary',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
            })}
          >
            <RegularErrorCircle size={36} />
          </div>

          <div
            className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: 'small',
            })}
          >
            <p
              className={css({
                color: 'neutrals.text_primary',
                fontSize: 'headline.large_semi_bold',
                fontWeight: 'headline.large_semi_bold',
                letterSpacing: 'headline.large_semi_bold',
                lineHeight: 'headline.large_semi_bold',
              })}
            >
              {translations.cancelPlanConfirmationTitle}
            </p>

            <p
              className={css({
                color: 'neutrals.text_primary',
                fontSize: 'body.medium',
                fontWeight: 'body.medium',
                letterSpacing: 'body.medium',
                lineHeight: 'body.medium',
              })}
            >
              {isConfirmedTransaction
                ? translations.cancelPlanInProgressConfirmationDescription
                : translations.cancelPlanConfirmationDescription}
            </p>
          </div>
        </section>

        <section
          className={css({
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 'extra_small_2',
            marginTop: 'auto',
            flexWrap: 'wrap',
            pt: 'medium',
          })}
        >
          <ButtonBase
            onClick={onConfirm}
            isLoading={isLoading}
            size="large"
            className={css({
              minWidth: '220px',
              flex: 1,
              maxWidth: '100%',
            })}
          >
            {translations.cancelPlan}
          </ButtonBase>

          <ButtonBase
            onClick={onClose}
            visual="secondary"
            size="large"
            className={css({
              minWidth: '220px',
              flex: 1,
              maxWidth: '100%',
            })}
          >
            {translations.goBack}
          </ButtonBase>
        </section>
      </div>
    </DialogBase>
  );
};
